/**
 * The apps of the page on screen — its route's `meta.app` — kept apart from
 * useApp so the router can set it without importing the composable.
 *
 * useApp's `isAdmin` reads it: on a page of an app the person holds only to
 * look at ("gl:view"), `isAdmin` is false, so the page's edit buttons hide.
 * The router sets it in beforeResolve (before the new page's setup runs) and
 * again after a navigation that failed (back to the page that stayed).
 */
import { ref } from "vue";

/** @type {import("vue").Ref<string[]|null>} null = a page that belongs to no app */
export const routeApps = ref(null);

/** Set from a route's meta.app (a string, an array, or nothing). */
export function setRouteApps(apps) {
  routeApps.value = apps == null ? null : Array.isArray(apps) ? [...apps] : [apps];
}
